<script setup>
import { computed } from 'vue'

const is1688 = computed(() => {
  return location.hostname.includes('1688')
})
</script>

<template>
  <header class="header">
    <div class="header-main">
      <div class="header-left">
        Shop
        <span>with</span>
        Confidence
      </div>
      <div class="header-gift">
        <img
          src="@/assets/header/header-gift.png"
          alt=""
        >
      </div>
      <div class="header-right">
        <div class="header-right-1">
          <div class="header-right-1-top">
            <span>{{ is1688 ? '1688' : 'Factory' }}</span> {{ is1688 ? 'Official Partner' : 'Direct Sales' }}
          </div>
          <div class="header-right-1-bottom">
            Billions of source goods
          </div>
        </div>
        <div />
      </div>
      <div class="header-right-2 header-right-support">
        <div class="header-right-2-top">
          Support Global <span> Payment</span>
        </div>
        <div class="header-right-2-bottom">
          Real-time exchange rate updates
        </div>
      </div>
      <div class="header-right-2">
        <div class="header-right-2-top">
          Support Global <span> Delivery</span>
        </div>
        <div class="header-right-2-bottom">
          One-stop service from procurement to logistics
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
@import './index.less';
</style>
